import { createContext, useContext } from "react";
import useForm from "../hooks/use-form";

const FormContext = createContext();

const FormProvider = ({ children }) => {
  
    const props = useForm();
    
    return (
        <FormContext.Provider value={{...props}}>
            {children}
        </FormContext.Provider>
    );
};

const useFormContext = () => {
    return useContext(FormContext);
};

export { FormProvider, useFormContext };